import { render, staticRenderFns } from "./detail3.vue?vue&type=template&id=139f4b5f&scoped=true&"
import script from "./detail3.vue?vue&type=script&lang=js&"
export * from "./detail3.vue?vue&type=script&lang=js&"
import style0 from "./detail3.vue?vue&type=style&index=0&id=139f4b5f&lang=scss&scoped=true&"
import style1 from "./detail3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f4b5f",
  null
  
)

export default component.exports